<script>

import {STATES} from "../../helpers/constantsHelper";
import {mapActions} from "vuex";
import {regexPatterns} from "../../utils/utils";

export default {
  name: "requestAgentKitDialog",
  data() {
    return {
      loading: false,
      requestAgentForm: {
        firstName: "",
        lastName: "",
        companyName: "",
        state: "",
        email: "",
        phoneNumber: "",
        message: ""
      },
      rules: {
        firstName: {
          required: true,
          message: "Please enter your first name",
          trigger: "blur"
        },
        lastName: {
          required: true,
          message: "Please enter your last name",
          trigger: "blur"
        },
        companyName: {
          required: true,
          message: "Please enter your company name",
          trigger: "blur"
        },
        state: {
          required: true,
          message: "Please select your state",
          trigger: ["change", "blur"]
        },
        email: {
          required: true,
          message: "Please enter a correct email",
          trigger: "blur",
          pattern: regexPatterns.email
        },
        phoneNumber: {
          required: true,
          message: "Please enter your phone number",
          trigger: "blur",
          pattern: regexPatterns.mobileRegEx
        },
        // message: {
        //   required: true,
        //   message: "Please enter your message",
        //   trigger: "blur"
        // }
      }
    }
  },
  props: {
    requestAgentDialogVisible: Boolean,
  },
  methods: {
    ...mapActions("request", ["sendRequestAgentKitEmail"]),
    STATES() {
      return STATES
    },
    validateField(field) {
      this.$refs.requestAgentForm.validateField(field);
    },
    formatPhoneNumber(value) {
      return value ? value.toString().replace(/[^\d]/g, '') : '';
    },
    handleClose() {
      this.$emit('update:requestAgentDialogVisible', false);
      this.requestAgentForm = {
        firstName: "",
        lastName: "",
        companyName: "",
        state: "",
        email: "",
        phoneNumber: "",
        message: ""
      };
      if (this.$refs.requestAgentForm) {
        this.$refs.requestAgentForm.clearValidate();
      }
      this.$emit('onClose');
    },
    onSubmit(formName) {
      if (this.loading) return;
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.loading) return;
          this.loading = true;
          this.sendRequestAgentKitEmail({
            params: {
              data: {
                firstName: this.requestAgentForm.firstName,
                lastName: this.requestAgentForm.lastName,
                companyName: this.requestAgentForm.companyName,
                state: this.requestAgentForm.state,
                email: this.requestAgentForm.email,
                phoneNumber: this.requestAgentForm.phoneNumber,
                message: this.requestAgentForm.message ? this.requestAgentForm.message : "N/A",
              },
            },
            callback: this.agentKitEmailCallback
          });
        } else {
          return false;
        }
      });
    },
    agentKitEmailCallback(res) {
      this.loading = false;
      if (res.data.code == 0) {
        this.handleClose();
        this.$message({
          showClose: true,
          message: 'Agent kit request sent successfully',
          type: 'success',
          duration: 6000
        });
      } else {
        this.$box.alert("", res.data.message, "error");
      }
    },
  }
}
</script>

<template>
    <el-dialog
      :show-close="false"
      :visible.sync="requestAgentDialogVisible"
      :before-close="handleClose"
      center
      fullscreen
      style="padding: 0 10px"
      custom-class="contact-dialog"
    >
      <template #title>
        <div class="contact-title">
          Request Agent Kit
          <div class="icon" @click="handleClose">
            <i class="el-icon-close"></i>
          </div>
        </div>
      </template>
      <div>

        <el-form
          ref="requestAgentForm"
          :model="requestAgentForm"
          :rules="rules"
          label-position="top"
          label-width="100px"
          @submit.native.prevent
          style="font-family: DINosaur-a, sans-serif;">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="First Name" prop="firstName">
                    <el-input
                      v-model="requestAgentForm.firstName"
                      maxlength="50"
                      placeholder="Your first name"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="Last Name" prop="lastName">
                    <el-input
                      v-model="requestAgentForm.lastName"
                      maxlength="100"
                      placeholder="Your last name"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="Company" prop="companyName">
                    <el-input
                      v-model="requestAgentForm.companyName"
                      maxlength="100"
                      placeholder="Agency/Developer name"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="Location" prop="state">
                    <el-select v-model="requestAgentForm.state" :popper-append-to-body="false" @change="validateField('state')" clearable filterable placeholder="Select a state" style="width: 100%;">
                      <el-option
                        v-for="item in STATES()"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="Email" prop="email">
                    <el-input
                      v-model="requestAgentForm.email"
                      maxlength="100"
                      placeholder="Your email"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="Phone Number" prop="phoneNumber">
                    <el-input
                      v-model="requestAgentForm.phoneNumber"
                      maxlength="20"
                      placeholder="Your phone number"
                      @input="requestAgentForm.phoneNumber = formatPhoneNumber($event)"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="Message" prop="message">
                    <el-input
                      type="textarea"
                      v-model="requestAgentForm.message"
                      maxlength="1000"
                      show-word-limit
                      placeholder="Message"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item style="text-align:center">
                    <el-button class="submit-button" @click="onSubmit('requestAgentForm')"
                    >Confirm
                      <i v-if="loading" class="el-icon-loading"></i>
                    </el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-dialog>
</template>

<style scoped>
.contact-title {
  color: #003333;
  text-align: left;
  font-size: 22px;
  font-family: DINosaur-a, sans-serif;
  font-weight: 600;
}

.contact-title .icon {
  float: right;
  width: 35px;
  height: 35px;
  font-size: 35px;
  cursor: pointer;
  color: #aaaaaa;
  position: relative;
  top: -15px;
  right: -10px;
}
.submit-button {
  width: 200px;
  height: 50px;
  color: #ffffff !important;
  text-align: center;
  border-radius: 5px;
  border: 4px solid #003333 !important;
  background-color: #003333 !important;
  font: 500 20px DINosaur-a, sans-serif;
  margin-top: 15px;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.el-form--label-top /deep/ .el-form-item__label {
  padding: 0 !important;
}
.el-dialog--center /deep/ .el-dialog__body {
  padding: 0 250px 30px 0 !important;
}
.el-select-dropdown__item {
  background-color: #ffffff;
  color: #003333;
}
.el-select-dropdown__item:hover {
  background-color: #003333;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/common/requestAgentKitDialog.vue